import { render, staticRenderFns } from "./OrderContainer.vue?vue&type=template&id=5df74f08&scoped=true"
import script from "./OrderContainer.vue?vue&type=script&lang=js"
export * from "./OrderContainer.vue?vue&type=script&lang=js"
import style0 from "./OrderContainer.vue?vue&type=style&index=0&id=5df74f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df74f08",
  null
  
)

export default component.exports